import { CARD, ROW } from '../../../constants/hipRecordsCopy';
import { formatDateIST, istCalendarDayIndex } from '../../../utils/formatIST';

// "Try again after <time>" for a PAUSED slot (the server throttles linking for a while).
//
// Retry-after is SECONDS REMAINING as served with the row. Turn it into a clock time ONCE per slot object
// (a re-render must not push "try again after" forward); every reader (the checklist row, the Replace
// lock reason, the card's paused note) reads the same instant, so they never disagree. A refetch brings a
// new slot object, hence a fresh instant.
const pausedAt = new WeakMap();
export function pausedUntilMs(slot) {
  if (!pausedAt.has(slot)) pausedAt.set(slot, Date.now() + (Number(slot.retryAfter) || 0) * 1000);
  return pausedAt.get(slot);
}

export const clockTimeIST = (ms) => new Date(ms).toLocaleTimeString('en-IN', {
  timeZone: 'Asia/Kolkata', hour: '2-digit', minute: '2-digit', hour12: true,
});

// OR-97: a block can last 24 h (ABDM-1027), so a bare clock time reads as "today" when it is tomorrow. ONE text for
// every "try again after ..." sentence: "08:42 pm" (today, IST) / "tomorrow, 08:42 pm" / "03 Nov, 08:42 pm" (later).
// "Today" is IST's calendar day (istCalendarDayIndex, fixed-offset arithmetic), never the UTC date of toISOString().
export function pausedWhenIST(ms) {
  const time = clockTimeIST(ms);
  const iso = new Date(ms).toISOString();
  const days = istCalendarDayIndex(iso) - istCalendarDayIndex(new Date(Date.now()).toISOString());
  if (days <= 0) return time;
  if (days === 1) return `${CARD.pausedTomorrow}, ${time}`;
  return `${formatDateIST(iso).replace(/ \d{4}$/, '')}, ${time}`;
}

// OR-99 / OR-108: the ONE "Paused. ..." / "ABDM has blocked linking ..." sentence of a PAUSED slot. The checklist row and the invoice
// form's Link reason both read it from here, off the SAME slot object, so the words and the time never differ.
export const pausedSentenceOf = (slot) => ROW.paused(pausedWhenIST(pausedUntilMs(slot)), slot.pauseReason);
